import { Dispatch } from "react";
import { ActionTypes, OtherDealerInventoryActions } from "./reducer/reducer";

export const onRowsPerPageChange = (
  dispatch: Dispatch<OtherDealerInventoryActions>,
  updatedRowsPerPage: number
): void => {
  dispatch({ type: ActionTypes.SET_PAGE_SIZE, payload: updatedRowsPerPage });
};

export const onFirstPageClick = (
  dispatch: Dispatch<OtherDealerInventoryActions>
): void => {
  dispatch({ type: ActionTypes.SET_CURRENT_PAGE, payload: 1 });
};

export const onPreviousPageClick = (
  dispatch: Dispatch<OtherDealerInventoryActions>,
  currentPage: number
): void => {
  dispatch({
    type: ActionTypes.SET_CURRENT_PAGE,
    payload: Math.max(currentPage - 1, 1),
  });
};

export const onNextClick = (
  dispatch: Dispatch<OtherDealerInventoryActions>,
  currentPage: number,
  totalItems: number,
  pageSize: number
): void => {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (currentPage < totalPages) {
    dispatch({ type: ActionTypes.SET_CURRENT_PAGE, payload: currentPage + 1 });
  }
};

export const onLastPageClick = (
  dispatch: Dispatch<OtherDealerInventoryActions>,
  pageRowSize: number,
  totalCount: number
): void => {
  dispatch({
    type: ActionTypes.SET_CURRENT_PAGE,
    payload: Math.max(Math.ceil(totalCount / pageRowSize), 1),
  });
};
